import { Header } from '@tanstack/react-table'

/**
 * Recursively calculates the maximum nested levels of a header's subheaders.
 */
export const getNestedLevels = (
    currentHeader: Header<unknown, unknown>
): number => {
    if (!currentHeader.subHeaders.length) return 1 // Base case
    return 1 + Math.max(...currentHeader.subHeaders.map(getNestedLevels))
}
